export const getLocaleForGlobalTrips = (locale: string) => {
  switch (locale) {
    case 'es_MX':
    case 'es_PE':
      return 'es_US';
    case 'en_IN':
      return 'en';
    default:
      return 'en';
  }
};
